import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '@shared/services/common.service';
import { ApiCallService } from '@services/api-call.service';
import { Application } from '@enums/application.enums';
import { APIENDPOINT } from '@core/api-url.enum';
import { SubscriptionsConstant } from '@modules/shared/constants/confirmation.constant';
import { Fields } from '@constants/constant';
import { getTrialEndDate } from '@utils/common.utils';

@Component({
  selector: 'app-post-subscription-list-popup',
  templateUrl: './post-subscription-list-popup.component.html',
  styleUrls: ['./post-subscription-list-popup.component.scss']
})
export class PostSubscriptionListPopupComponent implements OnInit {
  @Input() data;
  popupObj = {
    optionType: Number(Application.ONE),
    indPriceValue: '',
    selectedSubscription: ''
  };
  SubscriptionsConstant: typeof SubscriptionsConstant = SubscriptionsConstant;
  showSubscriptionDetail = false;
  currSelectedSubscription;
  selectedSubsPackage;
  subscribedPlans;
  Fields = Fields
  Application = Application;

  constructor(
    public readonly cs: CommonService,
    private readonly apiCallService: ApiCallService,
    private readonly activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    if (this.cs.isBrowser) {
      this.initForm();
    }
  }

  initForm(): void {
    this.subscribedPlans = this.data.subscribedPlan;
    this.currSelectedSubscription = this.data.user;
    this.popupObj.indPriceValue = this.data?.individual_price;
    if (this.data?.subscription?.length) {
      this.popupObj.selectedSubscription =
        this.data?.subscription[Application.ZERO].sk;
      this.selectSubscription(this.data?.subscription[Application.ZERO]);
    }
  }

  cancelModal(): void {
    this.activeModal.close(false);
  }

  getAmountFromSubsList(type: number): string {
    let amount = '';
    if (!this.popupObj.selectedSubscription) {
      return amount;
    }
    const obj = this.data?.subscription.find(
      (ele) => ele.sk === this.popupObj.selectedSubscription
    );
    if (obj) {
      amount = type === Application.ONE ? obj.amount : obj.discount_offer;
    }
    return amount;
  }

  getDurationFromSubsList(): string {
    let duration = '';
    if (!this.popupObj.selectedSubscription) {
      return duration;
    }
    const obj = this.data?.subscription.find(
      (ele) => ele.sk === this.popupObj.selectedSubscription
    );
    if (obj) {
      duration = obj.duration;
    }
    return duration;
  }

  selectSubscription(subs) {
    this.apiCallService
      .get(
        APIENDPOINT.getSubscriptionDetails(
          this.cs.encodeToUTF(subs?.pk),
          this.cs.encodeToUTF(subs?.sk)
        ),
        false
      )
      .subscribe({
        next: (res: any) => {
          this.currSelectedSubscription = res?.data[Application.ZERO];
          let selectedSubsPackage = null;
          const planDetails = this.currSelectedSubscription?.plan_details;
          for (let i = planDetails?.length - 1; i >= 0; i--) {
            const pack = planDetails[i];
            if (pack?.trial_enable && !pack?.is_subscribed) {
              selectedSubsPackage = pack;
              break;
            }
          }
          this.selectedSubsPackage = selectedSubsPackage || planDetails[Application.ZERO];
          this.currSelectedSubscription.plan_details.forEach((pack) => {
            pack.is_subscribed = this.checkSubscribeStatus(pack);
          });
        },
        error: (err: any) => {
          this.cs.showErrorMessage(err.message);
        }
      });
  }

  checkSubscribeStatus(subplan): boolean {
    const arr = this.subscribedPlans.filter(
      (ele) => ele.active && ele.subplan_id === subplan.id
    );
    return arr.length ? true : false;
  }

  selectPlan(plan) {
    this.selectedSubsPackage = plan;
  }

  select(): void {
    if (this.popupObj.optionType !== Application.ONE) {
      const data = {
        post_id: this.data?.sk,
        type:
          this.popupObj.optionType === Application.ONE
            ? 'subscription'
            : 'individual',
        plan_id:
          this.popupObj.optionType === Application.ONE
            ? this.popupObj.selectedSubscription
            : '',
        plan_user_id: `USER#${this.data?.user.gsi4pk}`,
        amount:
          this.popupObj.optionType !== Application.ONE
            ? this.popupObj.indPriceValue
            : this.getAmountFromSubsList(Application.ONE),
        plan_discount:
          this.popupObj.optionType !== Application.ONE
            ? Application.ZERO
            : this.getAmountFromSubsList(Application.TWO),
        duration:
          this.popupObj.optionType !== Application.ONE
            ? Application.ZERO
            : this.getDurationFromSubsList()
      };
      this.activeModal.close(data);
    } else {
      this.showSubscriptionDetail = true;
    }
  }

  goToPaymentForSubscription(plan) {
    const trial_end_date = getTrialEndDate(plan?.trial_days)  
    const data = {
      post_id: this.data?.sk,
      type: 'subscription',
      plan_id: this.currSelectedSubscription.sk,
      plan_user_id: this.currSelectedSubscription.pk,
      amount: plan.price,
      plan_discount: plan.discount,
      duration: plan?.duration,
      sub_plan_id: plan.id,
      features: this.currSelectedSubscription?.features,
      user: this.currSelectedSubscription?.user_details
        ? this.currSelectedSubscription?.user_details
        : null,
      plan_name: this.currSelectedSubscription.name,
      trial_enable: plan?.trial_enable,
      trial_days: plan?.trial_days,
      trial_end_date: trial_end_date,
      free_dms_count: this.currSelectedSubscription?.free_dms_count,
      is_unlimited_free_dms: this.currSelectedSubscription?.is_unlimited_free_dms
    };
    this.activeModal.close(data);
  }
}
